<!-- https://medium.com/@dhormale/use-google-places-api-autocomplete-using-angular-for-resident-and-office-address-23cc33078e8 -->
<input
  type="text"
  (change)="placeChangedText($event, addresstext)"
  pInputText
  [(ngModel)]="address"
  #addresstext
  [required]="isRequired === true"
/>
